// Optimized version of the Profile component
import { useEffect, useState } from "react";
import DocumentMeta from "react-document-meta";
import { toast, ToastContainer } from "react-toastify";
import axios from "axios";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";

import LoginHeader from "../Common/LoginHeader";
import Footer from "../Common/Footer";
import LeftTab from "../Common/LeftTab";
import { baseUrl } from "../Common/BaseUrl";
import UserInfo from "../Profile/UserInfo";
import GoogleAuth from "../Profile/GoogleAuth";
import ChangePassword from "../Profile/ChangePassword";

const meta = {
  title: "Profile | Green Crypto Exchange",
  description:
    "Green Crypto Exchange Live Makes The Buying And Selling Of Crypto Coin Way More Effective And Profitable. We Are A Low Cost Cyrpto Exchange In India Like Bitcoin And Dogecoin.",
  canonical: "https://venrypto.com",
  meta: {
    charset: "utf-8",
    name: {
      keywords:
        "BTC Exchange, Crypto Trading Platform, Best Crypto Converter, Indian Crypto Exchange",
    },
  },
};

const Profile = () => {
  // const [userData, setUserData] = useState({
  //   firstName: "",
  //   lastName: "",
  //   email: "",
  //   mobile_number: "",
  //   selfieStatus: 0,
  //   passportStatus: 0,
  //   identityStatus: 0,
  //   pancardStatus: 0,
  //   kycStatus: "N",
  //   image: "",
  //   blockStatus: false,
  //   enable_2fa: "",
  // });

  // const [loginData, setLoginData] = useState({
  //   tabledata: [],
  //   qrcodeurl: "assets/img/qr-dummy.png",
  //   SKey: "",
  //   vcode: "",
  //   message: "",
  //   isBlur: true,
  //   TwoFaText: "Enable",
  // });

  // useEffect(() => {
  //   getUserDetails();
  //   fetchLoginActivity();
  //   generateGoogleCode();
  // }, []);

  // const axiosConfig = {
  //   headers: {
  //     Authorization: `Bearer ${localStorage.getItem("jwtToken")}`,
  //   },
  // };

  // const getUserDetails = async () => {
  //   try {
  //     const { data } = await axios.post(
  //       baseUrl + "/frontapi/UserData",
  //       {},
  //       axiosConfig
  //     );
  //     const user = data?.data?.[0];
  //     if (data.status && user) {
  //       setUserData({
  //         ...userData,
  //         firstName: user.firstName,
  //         lastName: user.lastName === "null" ? "" : user.lastName,
  //         email: user.email,
  //         mobile_number: user.mobile_no,
  //         selfieStatus: user.selfie_status,
  //         passportStatus: user.passport_status,
  //         identityStatus: user.identity_status,
  //         pancardStatus: user.image3_status,
  //         kycStatus: user.kycVerification_status,
  //         image: user.profile_image,
  //         blockStatus: user.is_deleted,
  //         enable_2fa: user.enable_2fa,
  //       });
  //       setLoginData((prev) => ({
  //         ...prev,
  //         TwoFaText: user.enable_2fa === "Y" ? "Disable" : "Enable",
  //       }));
  //     } else if (data.key === "logout") {
  //       toast.error(data.message);
  //       localStorage.clear();
  //       window.location.href = "/login";
  //     }
  //   } catch (err) {
  //     console.error(err);
  //   }
  // };

  // const fetchLoginActivity = async () => {
  //   try {
  //     const { data } = await axios.post(
  //       baseUrl + "/frontapi/login-list",
  //       {},
  //       axiosConfig
  //     );
  //     if (data.status)
  //       setLoginData((prev) => ({ ...prev, tabledata: data.findData }));
  //   } catch (err) {
  //     console.error(err);
  //   }
  // };

  // const generateGoogleCode = async () => {
  //   try {
  //     const { data } = await axios.post(
  //       baseUrl + "/frontapi/generateGoogleCode",
  //       {},
  //       axiosConfig
  //     );
  //     setLoginData((prev) => ({
  //       ...prev,
  //       qrcodeurl: data.qrCodeUrl,
  //       SKey: data.secretKey,
  //     }));
  //   } catch (err) {
  //     console.error(err);
  //   }
  // };

  // const handleChange = (e) => {
  //   const val = e.target.value;
  //   if (!val.trim()) {
  //     setLoginData((prev) => ({
  //       ...prev,
  //       message: "This field is required",
  //       vcode: val,
  //     }));
  //     return;
  //   }
  //   setLoginData((prev) => ({ ...prev, message: "", vcode: val }));
  // };

  // const verifyCode = async () => {
  //   if (!loginData.vcode) {
  //     setLoginData((prev) => ({ ...prev, message: "This field is required" }));
  //     return;
  //   }

  //   const faData = {
  //     code: loginData.vcode,
  //     TwoFaText: loginData.TwoFaText,
  //   };

  //   try {
  //     const { data } = await axios.post(
  //       baseUrl + "/frontapi/verifyGoogleCode",
  //       faData,
  //       axiosConfig
  //     );
  //     if (data.status) {
  //       toast.success(data.message);
  //       setLoginData((prev) => ({ ...prev, vcode: "", isBlur: false }));
  //       getUserDetails();
  //     } else {
  //       toast.error(data.message);
  //     }
  //   } catch (err) {
  //     toast.error("Something went wrong");
  //   }
  // };

  // const deleteUser = async () => {
  //   try {
  //     const { data } = await axios.post(
  //       baseUrl + "/frontapi/delete-user",
  //       {},
  //       axiosConfig
  //     );
  //     if (data.status) {
  //       toast.success(data.message);
  //       localStorage.clear();
  //       setTimeout(() => (window.location.href = "/login"), 2000);
  //     } else toast.error(data.message);
  //   } catch (err) {
  //     toast.error("Deletion failed");
  //   }
  // };

  // const updateProfileImage = async (e) => {
  //   const formData = new FormData();
  //   formData.append("image", e.target.files[0]);
  //   try {
  //     const { data } = await axios.post(
  //       baseUrl + "/frontapi/update-profile-image",
  //       formData,
  //       axiosConfig
  //     );
  //     if (data.status) {
  //       toast.success(data.message);
  //       getUserDetails();
  //     } else {
  //       toast.error(data.message);
  //     }
  //   } catch (err) {
  //     toast.error("Upload failed");
  //   }
  // };

  // const handleValidation = (e) => {
  //   if (/[eE\-+!@#$%^&*()]/.test(e.key)) e.preventDefault();
  // };

  // const renderTooltipText = (text, limit, modifier) =>
  //   text.length > limit ? (
  //     <OverlayTrigger
  //       placement="top"
  //       overlay={
  //         <Tooltip>
  //           <strong>{text}</strong>
  //         </Tooltip>
  //       }
  //     >
  //       <span>{modifier(text)}</span>
  //     </OverlayTrigger>
  //   ) : (
  //     <span>{text || "-"}</span>
  //   );

  // const truncate = (text, length) =>
  //   text.length > length ? `${text.slice(0, length)}...` : text;

  return (
    <DocumentMeta {...meta}>
      <LoginHeader />
      <div className="bghwhite">
        <div className="new_inpage">
          <div class="container container2">
            <LeftTab />
            <div className="google-auth ">
              <div className="row">
                <UserInfo />
                <ChangePassword />
                <GoogleAuth />
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </DocumentMeta>
  );
};

export default Profile;
